import React, { useState, useEffect } from 'react';
import Restapi from '@utils/api';
import PropTypes from 'prop-types';
import { useApp } from '../../ssr/shared/application-context';
import Text from '@text';
import store from '@utils/store.js';
import { Button, Icon } from 'audamatic-ui';
import Portal from '@components/ui_portal/component.jsx';
import StorePicker from '@components/sec_store-finder/component';

const ChooseStoreButton = (props) => {
  const { textKey, variant, icon, setPreferredStore = true, setSelectedStoreId, updateStoreStockFilter } = props;
  const appCtx = useApp();
  const { stores, fetchStores } = appCtx;
  const [showStorePicker, setShowStorePicker] = useState(false);
  const api = new Restapi();

  useEffect(() => {
    if (!stores) {
      fetchStores();
    }
  }, [])

  const openStorePicker = () => setShowStorePicker(true);
  const closeStorePicker = () => setShowStorePicker(false);

  const selectStore = (storeId) => {
    if (setPreferredStore) {
      api.assignPreferredStoreToCustomer(storeId).then(() => {
        appCtx.setPreferredStoreId(storeId);
        closeStorePicker();
      })
        .then(() => store.loadBasket());
    } else if (setSelectedStoreId) {
      updateStoreStockFilter();
      setSelectedStoreId(storeId);
      closeStorePicker();
    }
  };

  return (
    <div className="choose-store-button">
      <Button
        variant={variant}
        size="large"
        iconLeft={icon ? <Icon name={icon} /> : null}
        onClick={openStorePicker}
        data-test-id="button-changeLocation"
      >
        {textKey && <Text>{textKey}</Text>}
      </Button>
      {StorePicker && showStorePicker && (
        <Portal>
          <StorePicker
            selectMode
            onClose={closeStorePicker}
            onSelect={selectStore}
            store={store}
            stores={stores}
            modal
          />
        </Portal>
      )}
    </div>
  );
};

ChooseStoreButton.propTypes = {
  textKey: PropTypes.string,
  variant: PropTypes.string,
  icon: PropTypes.string,
  setPreferredStore: PropTypes.bool,
  setSelectedStoreId: PropTypes.func,
  updateStoreStockFilter: PropTypes.func,
};

export default ChooseStoreButton;
